import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TablistContextProvider } from './TablistContext-DrXcHBdK.js';
import { N as Nav } from './Nav-BhLqKQHc.js';
import { a as TaktIdProvider } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30065889__sc-jj0i00-0"
})(["position:relative;", ""], isMobile(css(["::after{position:absolute;height:100%;width:", ";left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;top:0;content:\" \";background:", ";}/*! @noflip */ [dir=\"rtl\"] &&::after{background:", ";right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"], ({
  theme
}) => theme.navigation.tabs.mobile.width, ({
  theme
}) => theme.navigation.tabs.mobile.scrollableIndicatorBackground, ({
  theme
}) => theme.navigation.tabs.mobile.scrollableIndicatorBackgroundRTL)));
class TabbedNavigation extends PureComponent {
  render() {
    const {
      children,
      tablist,
      taktId,
      taktValue
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('tabbed-navigation')
    }, /*#__PURE__*/React__default.createElement(TablistContextProvider, {
      isTablist: tablist !== null && tablist !== void 0 ? tablist : false
    }, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Nav, null, children))));
  }
}
_defineProperty(TabbedNavigation, "propTypes", {
  /**
   * A set of TabbedNavigationItem components
   */
  children: PT.node.isRequired,
  /**
   * set to true if TabbedNavigation is for tabs that control content on the same page.
   */
  tablist: PT.bool
});
_defineProperty(TabbedNavigation, "defaultProps", {
  tablist: false
});

export { TabbedNavigation as T };
//# sourceMappingURL=TabbedNavigation-BiQ2meIW.js.map
